/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/app'
import { Route as ConsoleRouteRouteImport } from './routes/console/route'
import { Route as DevelopersRouteImport } from './routes/developers'
import { Route as FareCheckRouteImport } from './routes/fare-check'
import { Route as OpenDataRouteImport } from './routes/open-data'
import { Route as OperatorRouteRouteImport } from './routes/operator/route'
import { Route as BookIndexRouteImport } from './routes/book/index'
import { Route as BookTripIdRouteImport } from './routes/book/$tripId'
import { Route as ComplaintsIndexRouteImport } from './routes/complaints/index'
import { Route as ComplaintsTrackingNoRouteImport } from './routes/complaints/$trackingNo'
import { Route as ComplaintsNewRouteImport } from './routes/complaints/new'
import { Route as ConsoleIndexRouteImport } from './routes/console/index'
import { Route as ConsoleAuditRouteImport } from './routes/console/audit'
import { Route as ConsoleComplaintsRouteImport } from './routes/console/complaints'
import { Route as ConsoleDemandRouteImport } from './routes/console/demand'
import { Route as ConsoleExpiryRouteImport } from './routes/console/expiry'
import { Route as ConsoleFaresRouteImport } from './routes/console/fares'
import { Route as ConsoleForecastRouteImport } from './routes/console/forecast'
import { Route as ConsoleOperatorsRouteImport } from './routes/console/operators'
import { Route as OperatorIndexRouteImport } from './routes/operator/index'
import { Route as OperatorReportRouteImport } from './routes/operator/report'
import { Route as OperatorSchedulesRouteRouteImport } from './routes/operator/schedules/route'
import { Route as OperatorStickersRouteImport } from './routes/operator/stickers'
import { Route as TicketsIndexRouteImport } from './routes/tickets/index'
import { Route as TicketsTicketIdRouteImport } from './routes/tickets/$ticketId'
import { Route as VIndexRouteImport } from './routes/v/index'
import { Route as VCodeRouteImport } from './routes/v/$code'
import { Route as OperatorSchedulesIndexRouteImport } from './routes/operator/schedules/index'
import { Route as OperatorSchedulesScheduleIdRouteImport } from './routes/operator/schedules/$scheduleId'
import { Route as OperatorSchedulesNewRouteImport } from './routes/operator/schedules/new'
import { Route as OperatorTripsTripIdIndexRouteImport } from './routes/operator/trips/$tripId/index'
import { Route as OperatorTripsTripIdScanRouteImport } from './routes/operator/trips/$tripId/scan'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const ConsoleRouteRoute = ConsoleRouteRouteImport.update({
  id: '/console',
  path: '/console',
  getParentRoute: () => rootRouteImport,
} as any)
const DevelopersRoute = DevelopersRouteImport.update({
  id: '/developers',
  path: '/developers',
  getParentRoute: () => rootRouteImport,
} as any)
const FareCheckRoute = FareCheckRouteImport.update({
  id: '/fare-check',
  path: '/fare-check',
  getParentRoute: () => rootRouteImport,
} as any)
const OpenDataRoute = OpenDataRouteImport.update({
  id: '/open-data',
  path: '/open-data',
  getParentRoute: () => rootRouteImport,
} as any)
const OperatorRouteRoute = OperatorRouteRouteImport.update({
  id: '/operator',
  path: '/operator',
  getParentRoute: () => rootRouteImport,
} as any)
const BookIndexRoute = BookIndexRouteImport.update({
  id: '/book/',
  path: '/book/',
  getParentRoute: () => rootRouteImport,
} as any)
const BookTripIdRoute = BookTripIdRouteImport.update({
  id: '/book/$tripId',
  path: '/book/$tripId',
  getParentRoute: () => rootRouteImport,
} as any)
const ComplaintsIndexRoute = ComplaintsIndexRouteImport.update({
  id: '/complaints/',
  path: '/complaints/',
  getParentRoute: () => rootRouteImport,
} as any)
const ComplaintsTrackingNoRoute = ComplaintsTrackingNoRouteImport.update({
  id: '/complaints/$trackingNo',
  path: '/complaints/$trackingNo',
  getParentRoute: () => rootRouteImport,
} as any)
const ComplaintsNewRoute = ComplaintsNewRouteImport.update({
  id: '/complaints/new',
  path: '/complaints/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ConsoleIndexRoute = ConsoleIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ConsoleRouteRoute,
} as any)
const ConsoleAuditRoute = ConsoleAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => ConsoleRouteRoute,
} as any)
const ConsoleComplaintsRoute = ConsoleComplaintsRouteImport.update({
  id: '/complaints',
  path: '/complaints',
  getParentRoute: () => ConsoleRouteRoute,
} as any)
const ConsoleDemandRoute = ConsoleDemandRouteImport.update({
  id: '/demand',
  path: '/demand',
  getParentRoute: () => ConsoleRouteRoute,
} as any)
const ConsoleExpiryRoute = ConsoleExpiryRouteImport.update({
  id: '/expiry',
  path: '/expiry',
  getParentRoute: () => ConsoleRouteRoute,
} as any)
const ConsoleFaresRoute = ConsoleFaresRouteImport.update({
  id: '/fares',
  path: '/fares',
  getParentRoute: () => ConsoleRouteRoute,
} as any)
const ConsoleForecastRoute = ConsoleForecastRouteImport.update({
  id: '/forecast',
  path: '/forecast',
  getParentRoute: () => ConsoleRouteRoute,
} as any)
const ConsoleOperatorsRoute = ConsoleOperatorsRouteImport.update({
  id: '/operators',
  path: '/operators',
  getParentRoute: () => ConsoleRouteRoute,
} as any)
const OperatorIndexRoute = OperatorIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OperatorRouteRoute,
} as any)
const OperatorReportRoute = OperatorReportRouteImport.update({
  id: '/report',
  path: '/report',
  getParentRoute: () => OperatorRouteRoute,
} as any)
const OperatorSchedulesRouteRoute = OperatorSchedulesRouteRouteImport.update({
  id: '/schedules',
  path: '/schedules',
  getParentRoute: () => OperatorRouteRoute,
} as any)
const OperatorStickersRoute = OperatorStickersRouteImport.update({
  id: '/stickers',
  path: '/stickers',
  getParentRoute: () => OperatorRouteRoute,
} as any)
const TicketsIndexRoute = TicketsIndexRouteImport.update({
  id: '/tickets/',
  path: '/tickets/',
  getParentRoute: () => rootRouteImport,
} as any)
const TicketsTicketIdRoute = TicketsTicketIdRouteImport.update({
  id: '/tickets/$ticketId',
  path: '/tickets/$ticketId',
  getParentRoute: () => rootRouteImport,
} as any)
const VIndexRoute = VIndexRouteImport.update({
  id: '/v/',
  path: '/v/',
  getParentRoute: () => rootRouteImport,
} as any)
const VCodeRoute = VCodeRouteImport.update({
  id: '/v/$code',
  path: '/v/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const OperatorSchedulesIndexRoute = OperatorSchedulesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OperatorSchedulesRouteRoute,
} as any)
const OperatorSchedulesScheduleIdRoute =
  OperatorSchedulesScheduleIdRouteImport.update({
    id: '/$scheduleId',
    path: '/$scheduleId',
    getParentRoute: () => OperatorSchedulesRouteRoute,
  } as any)
const OperatorSchedulesNewRoute = OperatorSchedulesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => OperatorSchedulesRouteRoute,
} as any)
const OperatorTripsTripIdIndexRoute =
  OperatorTripsTripIdIndexRouteImport.update({
    id: '/trips/$tripId/',
    path: '/trips/$tripId/',
    getParentRoute: () => OperatorRouteRoute,
  } as any)
const OperatorTripsTripIdScanRoute = OperatorTripsTripIdScanRouteImport.update({
  id: '/trips/$tripId/scan',
  path: '/trips/$tripId/scan',
  getParentRoute: () => OperatorRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/console': typeof ConsoleRouteRouteWithChildren
  '/operator': typeof OperatorRouteRouteWithChildren
  '/app': typeof AppRoute
  '/developers': typeof DevelopersRoute
  '/fare-check': typeof FareCheckRoute
  '/open-data': typeof OpenDataRoute
  '/operator/schedules': typeof OperatorSchedulesRouteRouteWithChildren
  '/book/$tripId': typeof BookTripIdRoute
  '/complaints/$trackingNo': typeof ComplaintsTrackingNoRoute
  '/complaints/new': typeof ComplaintsNewRoute
  '/console/audit': typeof ConsoleAuditRoute
  '/console/complaints': typeof ConsoleComplaintsRoute
  '/console/demand': typeof ConsoleDemandRoute
  '/console/expiry': typeof ConsoleExpiryRoute
  '/console/fares': typeof ConsoleFaresRoute
  '/console/forecast': typeof ConsoleForecastRoute
  '/console/operators': typeof ConsoleOperatorsRoute
  '/operator/report': typeof OperatorReportRoute
  '/operator/stickers': typeof OperatorStickersRoute
  '/tickets/$ticketId': typeof TicketsTicketIdRoute
  '/v/$code': typeof VCodeRoute
  '/book/': typeof BookIndexRoute
  '/complaints/': typeof ComplaintsIndexRoute
  '/console/': typeof ConsoleIndexRoute
  '/operator/': typeof OperatorIndexRoute
  '/tickets/': typeof TicketsIndexRoute
  '/v/': typeof VIndexRoute
  '/operator/schedules/$scheduleId': typeof OperatorSchedulesScheduleIdRoute
  '/operator/schedules/new': typeof OperatorSchedulesNewRoute
  '/operator/schedules/': typeof OperatorSchedulesIndexRoute
  '/operator/trips/$tripId/scan': typeof OperatorTripsTripIdScanRoute
  '/operator/trips/$tripId/': typeof OperatorTripsTripIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/app': typeof AppRoute
  '/developers': typeof DevelopersRoute
  '/fare-check': typeof FareCheckRoute
  '/open-data': typeof OpenDataRoute
  '/book/$tripId': typeof BookTripIdRoute
  '/complaints/$trackingNo': typeof ComplaintsTrackingNoRoute
  '/complaints/new': typeof ComplaintsNewRoute
  '/console/audit': typeof ConsoleAuditRoute
  '/console/complaints': typeof ConsoleComplaintsRoute
  '/console/demand': typeof ConsoleDemandRoute
  '/console/expiry': typeof ConsoleExpiryRoute
  '/console/fares': typeof ConsoleFaresRoute
  '/console/forecast': typeof ConsoleForecastRoute
  '/console/operators': typeof ConsoleOperatorsRoute
  '/operator/report': typeof OperatorReportRoute
  '/operator/stickers': typeof OperatorStickersRoute
  '/tickets/$ticketId': typeof TicketsTicketIdRoute
  '/v/$code': typeof VCodeRoute
  '/book': typeof BookIndexRoute
  '/complaints': typeof ComplaintsIndexRoute
  '/console': typeof ConsoleIndexRoute
  '/operator': typeof OperatorIndexRoute
  '/tickets': typeof TicketsIndexRoute
  '/v': typeof VIndexRoute
  '/operator/schedules/$scheduleId': typeof OperatorSchedulesScheduleIdRoute
  '/operator/schedules/new': typeof OperatorSchedulesNewRoute
  '/operator/schedules': typeof OperatorSchedulesIndexRoute
  '/operator/trips/$tripId/scan': typeof OperatorTripsTripIdScanRoute
  '/operator/trips/$tripId': typeof OperatorTripsTripIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/console': typeof ConsoleRouteRouteWithChildren
  '/operator': typeof OperatorRouteRouteWithChildren
  '/app': typeof AppRoute
  '/developers': typeof DevelopersRoute
  '/fare-check': typeof FareCheckRoute
  '/open-data': typeof OpenDataRoute
  '/operator/schedules': typeof OperatorSchedulesRouteRouteWithChildren
  '/book/$tripId': typeof BookTripIdRoute
  '/complaints/$trackingNo': typeof ComplaintsTrackingNoRoute
  '/complaints/new': typeof ComplaintsNewRoute
  '/console/audit': typeof ConsoleAuditRoute
  '/console/complaints': typeof ConsoleComplaintsRoute
  '/console/demand': typeof ConsoleDemandRoute
  '/console/expiry': typeof ConsoleExpiryRoute
  '/console/fares': typeof ConsoleFaresRoute
  '/console/forecast': typeof ConsoleForecastRoute
  '/console/operators': typeof ConsoleOperatorsRoute
  '/operator/report': typeof OperatorReportRoute
  '/operator/stickers': typeof OperatorStickersRoute
  '/tickets/$ticketId': typeof TicketsTicketIdRoute
  '/v/$code': typeof VCodeRoute
  '/book/': typeof BookIndexRoute
  '/complaints/': typeof ComplaintsIndexRoute
  '/console/': typeof ConsoleIndexRoute
  '/operator/': typeof OperatorIndexRoute
  '/tickets/': typeof TicketsIndexRoute
  '/v/': typeof VIndexRoute
  '/operator/schedules/$scheduleId': typeof OperatorSchedulesScheduleIdRoute
  '/operator/schedules/new': typeof OperatorSchedulesNewRoute
  '/operator/schedules/': typeof OperatorSchedulesIndexRoute
  '/operator/trips/$tripId/scan': typeof OperatorTripsTripIdScanRoute
  '/operator/trips/$tripId/': typeof OperatorTripsTripIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/console'
    | '/operator'
    | '/app'
    | '/developers'
    | '/fare-check'
    | '/open-data'
    | '/operator/schedules'
    | '/book/$tripId'
    | '/complaints/$trackingNo'
    | '/complaints/new'
    | '/console/audit'
    | '/console/complaints'
    | '/console/demand'
    | '/console/expiry'
    | '/console/fares'
    | '/console/forecast'
    | '/console/operators'
    | '/operator/report'
    | '/operator/stickers'
    | '/tickets/$ticketId'
    | '/v/$code'
    | '/book/'
    | '/complaints/'
    | '/console/'
    | '/operator/'
    | '/tickets/'
    | '/v/'
    | '/operator/schedules/$scheduleId'
    | '/operator/schedules/new'
    | '/operator/schedules/'
    | '/operator/trips/$tripId/scan'
    | '/operator/trips/$tripId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/app'
    | '/developers'
    | '/fare-check'
    | '/open-data'
    | '/book/$tripId'
    | '/complaints/$trackingNo'
    | '/complaints/new'
    | '/console/audit'
    | '/console/complaints'
    | '/console/demand'
    | '/console/expiry'
    | '/console/fares'
    | '/console/forecast'
    | '/console/operators'
    | '/operator/report'
    | '/operator/stickers'
    | '/tickets/$ticketId'
    | '/v/$code'
    | '/book'
    | '/complaints'
    | '/console'
    | '/operator'
    | '/tickets'
    | '/v'
    | '/operator/schedules/$scheduleId'
    | '/operator/schedules/new'
    | '/operator/schedules'
    | '/operator/trips/$tripId/scan'
    | '/operator/trips/$tripId'
  id:
    | '__root__'
    | '/'
    | '/console'
    | '/operator'
    | '/app'
    | '/developers'
    | '/fare-check'
    | '/open-data'
    | '/operator/schedules'
    | '/book/$tripId'
    | '/complaints/$trackingNo'
    | '/complaints/new'
    | '/console/audit'
    | '/console/complaints'
    | '/console/demand'
    | '/console/expiry'
    | '/console/fares'
    | '/console/forecast'
    | '/console/operators'
    | '/operator/report'
    | '/operator/stickers'
    | '/tickets/$ticketId'
    | '/v/$code'
    | '/book/'
    | '/complaints/'
    | '/console/'
    | '/operator/'
    | '/tickets/'
    | '/v/'
    | '/operator/schedules/$scheduleId'
    | '/operator/schedules/new'
    | '/operator/schedules/'
    | '/operator/trips/$tripId/scan'
    | '/operator/trips/$tripId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ConsoleRouteRoute: typeof ConsoleRouteRouteWithChildren
  OperatorRouteRoute: typeof OperatorRouteRouteWithChildren
  AppRoute: typeof AppRoute
  DevelopersRoute: typeof DevelopersRoute
  FareCheckRoute: typeof FareCheckRoute
  OpenDataRoute: typeof OpenDataRoute
  BookTripIdRoute: typeof BookTripIdRoute
  ComplaintsTrackingNoRoute: typeof ComplaintsTrackingNoRoute
  ComplaintsNewRoute: typeof ComplaintsNewRoute
  TicketsTicketIdRoute: typeof TicketsTicketIdRoute
  VCodeRoute: typeof VCodeRoute
  BookIndexRoute: typeof BookIndexRoute
  ComplaintsIndexRoute: typeof ComplaintsIndexRoute
  TicketsIndexRoute: typeof TicketsIndexRoute
  VIndexRoute: typeof VIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/console': {
      id: '/console'
      path: '/console'
      fullPath: '/console'
      preLoaderRoute: typeof ConsoleRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/developers': {
      id: '/developers'
      path: '/developers'
      fullPath: '/developers'
      preLoaderRoute: typeof DevelopersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fare-check': {
      id: '/fare-check'
      path: '/fare-check'
      fullPath: '/fare-check'
      preLoaderRoute: typeof FareCheckRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/open-data': {
      id: '/open-data'
      path: '/open-data'
      fullPath: '/open-data'
      preLoaderRoute: typeof OpenDataRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/operator': {
      id: '/operator'
      path: '/operator'
      fullPath: '/operator'
      preLoaderRoute: typeof OperatorRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/book/': {
      id: '/book/'
      path: '/book'
      fullPath: '/book/'
      preLoaderRoute: typeof BookIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/book/$tripId': {
      id: '/book/$tripId'
      path: '/book/$tripId'
      fullPath: '/book/$tripId'
      preLoaderRoute: typeof BookTripIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/complaints/': {
      id: '/complaints/'
      path: '/complaints'
      fullPath: '/complaints/'
      preLoaderRoute: typeof ComplaintsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/complaints/$trackingNo': {
      id: '/complaints/$trackingNo'
      path: '/complaints/$trackingNo'
      fullPath: '/complaints/$trackingNo'
      preLoaderRoute: typeof ComplaintsTrackingNoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/complaints/new': {
      id: '/complaints/new'
      path: '/complaints/new'
      fullPath: '/complaints/new'
      preLoaderRoute: typeof ComplaintsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/console/': {
      id: '/console/'
      path: '/'
      fullPath: '/console/'
      preLoaderRoute: typeof ConsoleIndexRouteImport
      parentRoute: typeof ConsoleRouteRoute
    }
    '/console/audit': {
      id: '/console/audit'
      path: '/audit'
      fullPath: '/console/audit'
      preLoaderRoute: typeof ConsoleAuditRouteImport
      parentRoute: typeof ConsoleRouteRoute
    }
    '/console/complaints': {
      id: '/console/complaints'
      path: '/complaints'
      fullPath: '/console/complaints'
      preLoaderRoute: typeof ConsoleComplaintsRouteImport
      parentRoute: typeof ConsoleRouteRoute
    }
    '/console/demand': {
      id: '/console/demand'
      path: '/demand'
      fullPath: '/console/demand'
      preLoaderRoute: typeof ConsoleDemandRouteImport
      parentRoute: typeof ConsoleRouteRoute
    }
    '/console/expiry': {
      id: '/console/expiry'
      path: '/expiry'
      fullPath: '/console/expiry'
      preLoaderRoute: typeof ConsoleExpiryRouteImport
      parentRoute: typeof ConsoleRouteRoute
    }
    '/console/fares': {
      id: '/console/fares'
      path: '/fares'
      fullPath: '/console/fares'
      preLoaderRoute: typeof ConsoleFaresRouteImport
      parentRoute: typeof ConsoleRouteRoute
    }
    '/console/forecast': {
      id: '/console/forecast'
      path: '/forecast'
      fullPath: '/console/forecast'
      preLoaderRoute: typeof ConsoleForecastRouteImport
      parentRoute: typeof ConsoleRouteRoute
    }
    '/console/operators': {
      id: '/console/operators'
      path: '/operators'
      fullPath: '/console/operators'
      preLoaderRoute: typeof ConsoleOperatorsRouteImport
      parentRoute: typeof ConsoleRouteRoute
    }
    '/operator/': {
      id: '/operator/'
      path: '/'
      fullPath: '/operator/'
      preLoaderRoute: typeof OperatorIndexRouteImport
      parentRoute: typeof OperatorRouteRoute
    }
    '/operator/report': {
      id: '/operator/report'
      path: '/report'
      fullPath: '/operator/report'
      preLoaderRoute: typeof OperatorReportRouteImport
      parentRoute: typeof OperatorRouteRoute
    }
    '/operator/schedules': {
      id: '/operator/schedules'
      path: '/schedules'
      fullPath: '/operator/schedules'
      preLoaderRoute: typeof OperatorSchedulesRouteRouteImport
      parentRoute: typeof OperatorRouteRoute
    }
    '/operator/stickers': {
      id: '/operator/stickers'
      path: '/stickers'
      fullPath: '/operator/stickers'
      preLoaderRoute: typeof OperatorStickersRouteImport
      parentRoute: typeof OperatorRouteRoute
    }
    '/tickets/': {
      id: '/tickets/'
      path: '/tickets'
      fullPath: '/tickets/'
      preLoaderRoute: typeof TicketsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tickets/$ticketId': {
      id: '/tickets/$ticketId'
      path: '/tickets/$ticketId'
      fullPath: '/tickets/$ticketId'
      preLoaderRoute: typeof TicketsTicketIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/v/': {
      id: '/v/'
      path: '/v'
      fullPath: '/v/'
      preLoaderRoute: typeof VIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/v/$code': {
      id: '/v/$code'
      path: '/v/$code'
      fullPath: '/v/$code'
      preLoaderRoute: typeof VCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/operator/schedules/': {
      id: '/operator/schedules/'
      path: '/'
      fullPath: '/operator/schedules/'
      preLoaderRoute: typeof OperatorSchedulesIndexRouteImport
      parentRoute: typeof OperatorSchedulesRouteRoute
    }
    '/operator/schedules/$scheduleId': {
      id: '/operator/schedules/$scheduleId'
      path: '/$scheduleId'
      fullPath: '/operator/schedules/$scheduleId'
      preLoaderRoute: typeof OperatorSchedulesScheduleIdRouteImport
      parentRoute: typeof OperatorSchedulesRouteRoute
    }
    '/operator/schedules/new': {
      id: '/operator/schedules/new'
      path: '/new'
      fullPath: '/operator/schedules/new'
      preLoaderRoute: typeof OperatorSchedulesNewRouteImport
      parentRoute: typeof OperatorSchedulesRouteRoute
    }
    '/operator/trips/$tripId/': {
      id: '/operator/trips/$tripId/'
      path: '/trips/$tripId'
      fullPath: '/operator/trips/$tripId/'
      preLoaderRoute: typeof OperatorTripsTripIdIndexRouteImport
      parentRoute: typeof OperatorRouteRoute
    }
    '/operator/trips/$tripId/scan': {
      id: '/operator/trips/$tripId/scan'
      path: '/trips/$tripId/scan'
      fullPath: '/operator/trips/$tripId/scan'
      preLoaderRoute: typeof OperatorTripsTripIdScanRouteImport
      parentRoute: typeof OperatorRouteRoute
    }
  }
}

interface ConsoleRouteRouteChildren {
  ConsoleAuditRoute: typeof ConsoleAuditRoute
  ConsoleComplaintsRoute: typeof ConsoleComplaintsRoute
  ConsoleDemandRoute: typeof ConsoleDemandRoute
  ConsoleExpiryRoute: typeof ConsoleExpiryRoute
  ConsoleFaresRoute: typeof ConsoleFaresRoute
  ConsoleForecastRoute: typeof ConsoleForecastRoute
  ConsoleOperatorsRoute: typeof ConsoleOperatorsRoute
  ConsoleIndexRoute: typeof ConsoleIndexRoute
}

const ConsoleRouteRouteChildren: ConsoleRouteRouteChildren = {
  ConsoleAuditRoute: ConsoleAuditRoute,
  ConsoleComplaintsRoute: ConsoleComplaintsRoute,
  ConsoleDemandRoute: ConsoleDemandRoute,
  ConsoleExpiryRoute: ConsoleExpiryRoute,
  ConsoleFaresRoute: ConsoleFaresRoute,
  ConsoleForecastRoute: ConsoleForecastRoute,
  ConsoleOperatorsRoute: ConsoleOperatorsRoute,
  ConsoleIndexRoute: ConsoleIndexRoute,
}

const ConsoleRouteRouteWithChildren = ConsoleRouteRoute._addFileChildren(
  ConsoleRouteRouteChildren,
)

interface OperatorSchedulesRouteRouteChildren {
  OperatorSchedulesScheduleIdRoute: typeof OperatorSchedulesScheduleIdRoute
  OperatorSchedulesNewRoute: typeof OperatorSchedulesNewRoute
  OperatorSchedulesIndexRoute: typeof OperatorSchedulesIndexRoute
}

const OperatorSchedulesRouteRouteChildren: OperatorSchedulesRouteRouteChildren =
  {
    OperatorSchedulesScheduleIdRoute: OperatorSchedulesScheduleIdRoute,
    OperatorSchedulesNewRoute: OperatorSchedulesNewRoute,
    OperatorSchedulesIndexRoute: OperatorSchedulesIndexRoute,
  }

const OperatorSchedulesRouteRouteWithChildren =
  OperatorSchedulesRouteRoute._addFileChildren(
    OperatorSchedulesRouteRouteChildren,
  )

interface OperatorRouteRouteChildren {
  OperatorSchedulesRouteRoute: typeof OperatorSchedulesRouteRouteWithChildren
  OperatorReportRoute: typeof OperatorReportRoute
  OperatorStickersRoute: typeof OperatorStickersRoute
  OperatorIndexRoute: typeof OperatorIndexRoute
  OperatorTripsTripIdScanRoute: typeof OperatorTripsTripIdScanRoute
  OperatorTripsTripIdIndexRoute: typeof OperatorTripsTripIdIndexRoute
}

const OperatorRouteRouteChildren: OperatorRouteRouteChildren = {
  OperatorSchedulesRouteRoute: OperatorSchedulesRouteRouteWithChildren,
  OperatorReportRoute: OperatorReportRoute,
  OperatorStickersRoute: OperatorStickersRoute,
  OperatorIndexRoute: OperatorIndexRoute,
  OperatorTripsTripIdScanRoute: OperatorTripsTripIdScanRoute,
  OperatorTripsTripIdIndexRoute: OperatorTripsTripIdIndexRoute,
}

const OperatorRouteRouteWithChildren = OperatorRouteRoute._addFileChildren(
  OperatorRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ConsoleRouteRoute: ConsoleRouteRouteWithChildren,
  OperatorRouteRoute: OperatorRouteRouteWithChildren,
  AppRoute: AppRoute,
  DevelopersRoute: DevelopersRoute,
  FareCheckRoute: FareCheckRoute,
  OpenDataRoute: OpenDataRoute,
  BookTripIdRoute: BookTripIdRoute,
  ComplaintsTrackingNoRoute: ComplaintsTrackingNoRoute,
  ComplaintsNewRoute: ComplaintsNewRoute,
  TicketsTicketIdRoute: TicketsTicketIdRoute,
  VCodeRoute: VCodeRoute,
  BookIndexRoute: BookIndexRoute,
  ComplaintsIndexRoute: ComplaintsIndexRoute,
  TicketsIndexRoute: TicketsIndexRoute,
  VIndexRoute: VIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
